exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerNavigation[data-v-5e9a4b97]{position:fixed;bottom:0;width:100%;height:48px;background:#fff;-webkit-box-shadow:0 -2px 8px 0 rgba(60,70,75,.2);box-shadow:0 -2px 8px 0 rgba(60,70,75,.2);z-index:5;display:block}.footerNavigation .tabbedNavigation[data-v-5e9a4b97]{margin:0 auto}@media (min-width:768px){.footerNavigation[data-v-5e9a4b97]{display:none}}", ""]);

// exports
